export const SEGMENTO_REMOVE = "SEGMENTO_REMOVE";
export const SEGMENTO_CREATE = "SEGMENTO_CREATE";
export const SEGMENTO_LOAD = "SEGMENTO_LOAD";
export const SEGMENTO_CLIENTE_LIST = "SEGMENTO_CLIENTE_LIST";
export const SEGMENTO_LIST = "SEGMENTO_LIST";
export const SEGMENTO_LIST_ALL = "SEGMENTO_LIST_ALL";
